/**
 * Icônes (feather) associées aux catégories du blog, indexées par `category.id`
 * (voir src/blog/data/categories.js — lecture seule, ne jamais modifier).
 * CompassIcon sert de repli si une catégorie inconnue apparaît.
 * Un seul point d’entrée : `getCategoryIcon`.
 */
import { ReactComponent as CpuIcon } from "feather-icons/dist/icons/cpu.svg";
import { ReactComponent as BriefcaseIcon } from "feather-icons/dist/icons/briefcase.svg";
import { ReactComponent as BookOpenIcon } from "feather-icons/dist/icons/book-open.svg";
import { ReactComponent as CalendarIcon } from "feather-icons/dist/icons/calendar.svg";
import { ReactComponent as AwardIcon } from "feather-icons/dist/icons/award.svg";
import { ReactComponent as MapPinIcon } from "feather-icons/dist/icons/map-pin.svg";
import { ReactComponent as CompassIcon } from "feather-icons/dist/icons/compass.svg";

const categoryIcons = {
  ia: CpuIcon,
  startups: BriefcaseIcon,
  recherche: BookOpenIcon,
  evenements: CalendarIcon,
  formation: AwardIcon,
  collectivites: MapPinIcon,
};

/** Icône d’une catégorie, avec repli sur la boussole. */
export const getCategoryIcon = id => categoryIcons[id] || CompassIcon;
